import { deleteTeamMember } from '../../../modules/member/member.repository';

export const deleteTeamMemberUseCase = (appMemberId: number): Promise<void> => {
  return deleteTeamMember(appMemberId);
};
